import createIcon from '../../createIcon';

/**
 * @component @name Task
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTAuOTQgMThMNy40IDE0LjQ2TDguODEgMTMuMDVMMTAuOTMgMTUuMTdMMTUuMTcgMTAuOTNMMTYuNTggMTIuMzRMMTAuOTQgMThaTTEzIDlWMy41TDE4LjUgOUgxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Task = createIcon('Task', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM10.94 18L7.4 14.46L8.81 13.05L10.93 15.17L15.17 10.93L16.58 12.34L10.94 18ZM13 9V3.5L18.5 9H13Z',
      key: '3vvd7m',
    },
  ],
]);

export default Task;
